// import React from 'react'
import useSWR from 'swr'

export default function useStates(id) {
  const {data: states, error, isValidating} = useSWR(`collections/countries.states/83`)

  return {
    states: states?.data,
    isLoading: isValidating,
    isError: error
  }
}